import { gql } from '@apollo/client';

export const STATUS_LIST = gql`
query($tableName: String!){
  statusList(tableName: $tableName)
}
`
